<template>
  <div class="item-box">
    <b-row v-if="!isClose || !columnIsTextInput" align-h="between">
      <b-col :style="{ 'margin-left': 32 * deep + 'px' }">
        <div v-if="!isClose&&item.type!=='text'" @click="select">
          <span v-show="!isClose">
            <span
              v-if="!isExpand"
              @click="shrink"
              :class="{ disabled: isAllHoseholds }"
              class="item-btn"
            >
              <icon name="plus" class="fold-icon"></icon>
            </span>
            <span
              v-if="isExpand"
              :class="{ disabled: isAllHoseholds }"
              class="item-btn"
            >
              <icon name="minus" class="fold-icon"></icon>
            </span>
          </span>
          <span class="type-link"
              :class="{ disabled: isAllHoseholds }">{{ item.AttributeDesc }}</span>
        </div>
        <span v-if="!isClose&&item.type==='text'">{{ item.AttributeDesc }}</span>
        <b-form-checkbox
          :id="item.code"
          v-if="isClose"
          :disabled="isAllHoseholds"
          class="custom-control-inline select-checkbox"
          v-model="isAdd"
          @change="onchange($event)"
        >
          {{ item.AttributeValueDesc }}</b-form-checkbox
        >
      </b-col>
    </b-row>
    <div
      v-if="isClose && columnIsTextInput"
      :style="{ 'margin-left': 32 * deep + 'px' }"
      class="input-box"
    >
      <div v-if="attributes.length !== 0">
        <p class="add-p">{{ attributes[0].AttributeValueDesc }}</p>
        <b-row>
          <b-col
            ><b-input
              v-model="inputFrom"
              class="input-box-input"
              :disabled="isAllHoseholds"
              size="sm"
              :placeholder="inputFromHolder"
          /></b-col>
          <b-col v-if="selectedColumnItem.DemoInputtype !== 9"
            ><b-input
              v-model="inputTo"
              :disabled="isAllHoseholds"
              class="input-box-input"
              size="sm"
              :placeholder="inputToHolder"
          /></b-col>
        </b-row>
        <b-btn
          size="sm"
          class="add-btn"
          :disabled="isAllHoseholds"
          @click="addDemo"
          >Add</b-btn
        >
        <span class="m-error-text" v-show="inputError !== false">{{
          inputError
        }}</span>
      </div>
    </div>
    <m-loader size="before" :show="!hasLoad" />
    <div v-if="hasLoad && isExpand && !isClose">
      <m-demo-select-item
        v-if="attributes.length > 0"
        :isClose="true"
        v-for="val in attributes"
        :demoType="demoType"
        :specialDemoCategory="specialDemoCategory"
        :item="val"
        :key="val.AttributesValuesId"
        :deep="thisDeep"
        :column="item"
      />
    </div>
  </div>
</template>
  
<script>
export default {
  name: "mDemoSelectItem",
  props: {
    item: {
      type: Object,
    },
    deep: {
      type: Number,
      default: 0,
    },
    demoType: {
      type: Number,
      default: 1,
    },
    specialDemoCategory: {
      type: [Number, Boolean],
      default: false,
    },
    isClose: {
      type: Boolean,
      default: false,
    },
    column: {
      type: Object,
    },
  },
  data() {
    return {
      isExpand: false,
      thisDeep: 0,
      isAllAddTemple: false,
      demoTypeInit: false,
      inputFrom: "",
      inputTo: "",
      inputError: "",
      hasLoad: true,
    };
  },
  computed: {
    listType() {
      if (this.$store.state.order.ListType) {
        return this.$store.state.order.ListType;
      } else {
        return 10;
      }
    },
    inputFromHolder() {
      let dict = {
        0: "",
        1: "YYYYMMDD",
        2: "Interger or Amount",
        3: "MMYYYY",
        4: "YYYY",
        5: "MM",
        6: "SIC Code",
        7: "String",
        8: "radio",
        9: "input or string",
      };
      if (dict.hasOwnProperty(this.selectedColumnItem.DemoInputtype)) {
        let str = dict[this.selectedColumnItem.DemoInputtype];
        let maxmin = "";
        if (this.selectedColumnItem.MinValue) {
          maxmin += "Min:" + this.selectedColumnItem.MinValue;
        }
        if (maxmin.length > 0) {
          maxmin += ";";
        }
        if (this.selectedColumnItem.MaxValue) {
          maxmin = "Max:" + this.selectedColumnItem.MaxValue;
        }
        if (maxmin.length > 0) {
          str += `(${maxmin})`;
        }
        return str;
      } else {
        return "";
      }
    },
    inputToHolder() {
      return this.inputFromHolder;
    },
    selectedColumnItem() {
      if (
        this.item.ColumnName.length !== 0 &&
        this.columns.hasOwnProperty(this.item.ColumnName)
      ) {
        this.inputFrom = "";
        this.inputTo = "";
        this.inputError = "";
        return this.columns[this.item.ColumnName];
      } else {
        return {};
      }
    },
    demos() {
      return this.$store.state.demo.demos;
    },
    selectedDemos() {
      let demos = this.$store.getters["order/demoItems"];
      let result = [];
      for (let column of demos) {
        // hide quick pick , business type
        if ([2, 5, 4, 6].indexOf(column.DemoCategoryType) === -1) {
          result.push({
            type: "column",
            columnName: column.ColumnName,
            name: column.AttributeName,
            demoCategoryType: column.DemoCategoryType,
          });
          for (let value of column.Values) {
            result.push({
              type: "value",
              attributeValue: value.AttributeValue,
              columnName: value.ColumnName,
              name: value.AttributeValueName,
              demoCategoryType: column.DemoCategoryType,
            });
          }
        }
      }
      return result;
    },
    columns() {
      if (
        this.listType in this.demos &&
        this.demoType in this.demos[this.listType]
      ) {
        return this.demos[this.listType][this.demoType];
      } else {
        this.getDemos();
        return [];
      }
    },
    attributes() {
      if (this.columns.hasOwnProperty(this.item.ColumnName)) {
        if (this.columns[this.item.ColumnName].Values.length === 0) {
          this.getAttributes();
        }
        return this.columns[this.item.ColumnName].Values;
      } else {
        return [];
      }
    },
    isAllHoseholds() {
      return this.$store.getters["order/isAllHoseholds"];
    },
    columnIsTextInput() {
      return (
        (this.column.DemoInputtype >= 1 && this.column.DemoInputtype <= 7) ||
        this.column.DemoInputtype === 9
      );
    },
    columnsIsCheck() {
      return (
        this.isClose ||
        (this.item.DemoInputtype >= 1 && this.item.DemoInputtype <= 7) ||
        this.item.DemoInputtype === 9
      );
    },
    isOnlyItem() {
      return this.item.DemoCategory === 8;
    },
    isAdd: {
      get() {
        return this.$store.getters["order/hasDemoByValue"](
          this.column.ColumnName,
          this.specialDemoCategory || 3,
          this.item.AttributeValue
        );
      },
      set(val) {},
    },
    isAllAdd: {
      get() {
        return this.isAllAddTemple;
      },
      set(val) {
        if (val) {
          if (this.columns.hasOwnProperty(this.item.ColumnName)) {
            this.addAllAttributesToDemo();
          } else {
            for (let item of this.attributes) {
              item.DemoCategoryType = this.item.specialDemoCategory || 3;
              item.AttributeName = this.item.AttributeName;
              item.AttributeDesc = this.item.AttributeDesc;
              this.$store.dispatch("order/addDemoByItem", item);
            }
          }
        } else {
          for (let item of this.attributes) {
            this.$store.dispatch("order/deleteDemo", {
              attributeValue: item.AttributeValue,
              type: "value",
              demoCategoryType: this.specialDemoCategory || 3,
              columnName: this.item.ColumnName,
            });
          }
        }
        this.isAllAddTemple = val;
      },
    },
    datasource() {
      return this.$store.getters["config/datasource"];
    },
    isAllHoseholds() {
      return this.$store.getters["order/isAllHoseholds"];
    },
  },
  mounted() {
    this.thisDeep = this.deep + 1;
  },
  methods: {
    onchange(val) {
      if (val) {
        this.addDemo();
      } else {
        this.$store.dispatch("order/deleteDemo", {
          attributeValue: this.item.AttributeValue,
          type: "value",
          demoCategoryType: this.specialDemoCategory || 3,
          columnName: this.column.ColumnName,
        });
      }
    },
    select() {
      if (this.isAllHoseholds) return;
      if (this.isExpand) {
        this.isExpand = false;
      } else if (!this.isExpand) {
        this.isExpand = true;
      }
    },
    shrink() {
      this.isExpand = false;
    },
    getDemos() {
      this.$http
        .post("PlaceOrder.aspx/GetDemoAttributesList", {
          demotype: this.demoType,
          listtype: this.listType,
        })
        .then((resp) => {
          let data = resp.body.d.DataSource;
          this.$store.commit("demo/saveColumns", {
            listType: this.listType,
            demoType: this.demoType,
            data,
          });
        });
    },
    getAttributes() {
      this.hasLoad = false;
      this.$http
        .post("PlaceOrder.aspx/GetDemoAttribute", {
          columnName: this.item.ColumnName,
          listtype: this.listType,
        })
        .then((resp) => {
          let data = resp.body.d.DataSource.DemoValues;
          if (resp.body.d.DataSource.DemoInputtype === 0 && data.length === 0) {
            data = [
              {
                AttributeValueDesc: "No available option",
                AttributeValue: "DoNotChooseThis",
              },
            ];
          } else if (
            resp.body.d.DataSource.DemoInputtype === 9 &&
            data.length === 0
          ) {
            data = [
              {
                AttributeValue: null,
                AttributeValueName: null,
                ColumnName: resp.body.d.DataSource.ColumnName,
              },
            ];
          } else if (
            resp.body.d.DataSource.DemoInputtype >= 1 &&
            resp.body.d.DataSource.DemoInputtype <= 7
          ) {
            data = [
              {
                AttributeValue: null,
                AttributeValueName: null,
                ColumnName: resp.body.d.DataSource.ColumnName,
              },
            ];
          }
          this.$store.commit("demo/saveAttributes", {
            listType: this.listType,
            demoType: this.demoType,
            columnName: this.item.ColumnName,
            demoCategory: resp.body.d.DataSource.DemoCategory,
            data,
          });
          this.hasLoad = true;
        });
    },
    addAllAttributesToDemo() {
      this.$http
        .post("PlaceOrder.aspx/GetDemoAttribute", {
          columnName: this.item.ColumnName,
          listtype: this.listType,
        })
        .then((resp) => {
          let data = resp.body.d.DataSource.DemoValues;
          if (resp.body.d.DataSource.DemoInputtype === 0 && data.length === 0) {
            data = [
              {
                AttributeValueDesc: "No available option",
                AttributeValue: "DoNotChooseThis",
              },
            ];
          } else if (
            resp.body.d.DataSource.DemoInputtype === 9 &&
            data.length === 0
          ) {
            data = [
              {
                AttributeValue: null,
                AttributeValueName: null,
                ColumnName: resp.body.d.DataSource.ColumnName,
              },
            ];
          } else if (
            resp.body.d.DataSource.DemoInputtype >= 1 &&
            resp.body.d.DataSource.DemoInputtype <= 7
          ) {
            data = [
              {
                AttributeValue: null,
                AttributeValueName: null,
                ColumnName: resp.body.d.DataSource.ColumnName,
              },
            ];
          } else {
            for (let item of data) {
              item.DemoCategoryType = this.item.specialDemoCategory || 3;
              item.AttributeName = this.item.AttributeName;
              item.AttributeDesc = this.item.AttributeDesc;
              this.$store.dispatch("order/addDemoByItem", item);
            }
          }
          this.$store.commit("demo/saveAttributes", {
            listType: this.listType,
            demoType: this.demoType,
            columnName: this.item.ColumnName,
            demoCategory: resp.body.d.DataSource.DemoCategory,
            data,
          });
        });
    },
    getAttrbiutesValue(columnName, val) {
      return {
        listType: this.listType,
        demoType: this.demoType,
        columnName: columnName,
        value: val,
      };
    },
    addDemo() {
      // demoInputType 1, 2, 3, 4, 5, 6, 7, 9
      //console.log(this.column, this.columnIsTextInput)
      if (this.columnIsTextInput) {
        let item = null;
        item = this.addDemoInput();
        if (item !== false) {
          item.DemoCategoryType = this.specialDemoCategory || 3;
          this.$store.dispatch("order/addDemoByItem", item);
        }
      } else if (
        this.column.DemoInputtype === 0 ||
        this.column.DemoInputtype === 8
      ) {
        if (
          this.column.DemoInputtype === 8 &&
          this.$store.getters["order/demoColumnIndex"](
            this.column.ColumnName,
            this.column.DemoCategoryType
          ) !== -1
        ) {
          notification.notice(
            "warning",
            "You can only choose one item for this category"
          );
          return false;
        }
        this.item.DemoCategoryType = this.specialDemoCategory || 3;
        this.item.AttributeName = this.column.AttributeName;
        this.item.AttributeDesc = this.column.AttributeDesc;
        this.$store.dispatch("order/addDemoByItem", this.item);
        return true;
      }
    },
    checkIsNumber(val) {
      if (isNaN(val) || val === null || val === "") {
        this.inputError = "Need Digital";
        return false;
      }
    },
    checkInput1DayMonthYearVal(val) {
      if (val.length !== 8) {
        this.inputError = "Need format: YYYYMMDD";
        return false;
      }

      let day = parseInt(val.substring(6, 8));
      let month = parseInt(val.substring(4, 6));
      let year = parseInt(val.substring(0, 4));

      if (
        year < 1000 ||
        year > 2099 ||
        month < 1 ||
        month > 12 ||
        day < 1 ||
        day > 31 ||
        isNaN(month) ||
        isNaN(year) ||
        isNaN(day)
      ) {
        this.inputError = "Need format: YYYYMMDD";
        return false;
      }
      return {
        day: val.substring(6, 8),
        month: val.substring(4, 6),
        year: val.substring(0, 4),
      };
    },
    checkInput2InterVal(val) {
      val = parseInt(val);
      if (isNaN(val)) {
        this.inputError = "Need Number";
        return false;
      }
      return val;
    },
    checkInput3MonthYearVal(val) {
      // 3 month year
      if (val.length !== 6) {
        this.inputError = "Need format: MMYYYY";
        return false;
      }
      let month = parseInt(val.substring(0, 2));
      let year = parseInt(val.substring(2, 6));
      if (
        year < 1000 ||
        year > 2099 ||
        month < 1 ||
        month > 12 ||
        isNaN(month) ||
        isNaN(year)
      ) {
        this.inputError = "Need format: MMYYYY";
        return false;
      }
      return { month: val.substring(0, 2), year: val.substring(2, 6) };
    },
    checkInput4YearVal(val, rules) {
      // 4 year, datasource10 demographics Year Home Built, checked
      if (val.length !== 4) {
        this.inputError = "Need format: YYYY";
        return false;
      }
      let year = parseInt(val);
      if (year < 1900 || year > 2099 || isNaN(year)) {
        this.inputError = "Need format: YYYY";
        return false;
      }
      return year;
    },
    checkInput5Month(val) {
      if (val.length !== 2) {
        this.inputError = "Need format: MM";
        return false;
      }
      let month = parseInt(val);
      if (month < 1 || month > 12 || isNaN(month)) {
        this.inputError = "Need format: MM";
        return false;
      }
      return val;
    },
    checkInput7String(val) {
      if (val.length === 0) {
        this.inputError = "Need String";
        return false;
      }
      return val;
    },
    checkToMoreFrom(from, to) {
      if (from > to) {
        this.inputError = "First input is smaller than second";
        return false;
      } else {
        return true;
      }
    },
    checkMaxMin(from, to, type) {
      let max = this.selectedColumnItem.MaxValue;
      let min = this.selectedColumnItem.MinValue;

      if (max !== null) {
        if (from > max || to > max) {
          this.inputError = "value must smaller than " + max;
        }
      }

      if (min !== null) {
        if (from < min || to < min) {
          this.inputError = "value must bigger than " + min;
        }
      }
    },
    checkOneMaxMin(from) {
      let max = this.selectedColumnItem.MaxValue;
      let min = this.selectedColumnItem.MinValue;
      if (max !== null) {
        if (from > max) {
          this.inputError = "value must smaller than " + max;
        }
      }

      if (min !== null) {
        if (from < min) {
          this.inputError = "value must bigger than " + min;
        }
      }
    },
    addDemoInput() {
      this.inputError = "";
      let item = this.selectedColumnItem;
      let from = null;
      let to = null;
      // check value fromate
      if (item.DemoInputtype === 1) {
        // Input DayMonthyear dataourece 40 data of publication
        from = this.checkInput1DayMonthYearVal(this.inputFrom);
        to = this.checkInput1DayMonthYearVal(this.inputTo);

        if (this.inputError === "") {
          this.checkToMoreFrom(
            `${from.year}${from.month}${from.day}`,
            `${to.year}${to.month}${to.day}`
          );
          this.checkMaxMin(
            `${from.year}${from.month}${from.day}`,
            `${to.year}${to.month}${to.day}`
          );
        }
      } else if (item.DemoInputtype === 2) {
        // InputInteger,  datasource10 audience propensities -> automotive -> Affinity fro a New
        from = this.checkInput2InterVal(this.inputFrom);
        to = this.checkInput2InterVal(this.inputTo);
      } else if (item.DemoInputtype === 3) {
        // InputMonthyear
        from = this.checkInput3MonthYearVal(this.inputFrom);
        to = this.checkInput3MonthYearVal(this.inputTo);
        if (this.inputError === "") {
          this.checkToMoreFrom(
            `${from.year}${from.month}`,
            `${to.year}${to.month}`
          );
          this.checkMaxMin(
            `${from.year}${from.month}`,
            `${to.year}${to.month}`
          );
        }
      } else if (item.DemoInputtype === 4) {
        // InputYear, datasource10 demographics Year Home Built
        from = this.checkInput4YearVal(this.inputFrom);
        to = this.checkInput4YearVal(this.inputTo);
      } else if (item.DemoInputtype === 5) {
        // inputMonth
        from = this.checkInput5Month(this.inputFrom);
        to = this.checkInput5Month(this.inputTo);
      } else if (item.DemoInputtype === 6) {
        // 6 SIC, datasource20 demographic SIC CODE
        // TODO@important I can't understood SIC CODE
        from = this.inputFrom;
        to = this.inputTo;
      } else if (item.DemoInputtype === 7) {
        // 7 InputString, datasource170 demographics upload codes
        // TODO@important maybe it not string
        from = this.inputFrom;
        to = this.inputTo;
        from = this.checkInput7String(this.inputFrom);
        to = this.checkInput7String(this.inputTo);
      } else if (item.DemoInputtype === 8) {
        // RadioSelectBox ,  prod datasource 40 demo，residential/Business Selector
        // TODO@important I can't find this type
        from = this.inputFrom;
        to = this.inputTo;
      } else if (item.DemoInputtype === 9) {
        // InputIntegerSingle,  prod datasource 160 demo  Corporate Sales Volume Actual, dev dataSource 10 small office - home office
        from = this.inputFrom;
        this.checkIsNumber(from);
        this.checkOneMaxMin(from);
      }

      // assignment
      if (this.inputError.length > 0) {
        return false;
      } else if (item.DemoInputtype === 1) {
        item.AttributeValue = `${from.year}${from.month}${from.day}~${to.year}${to.month}${to.day}`;
        item.AttributeValueName = `${from.year}${from.month}${from.day}~${to.year}${to.month}${to.day}`;
      } else if (item.DemoInputtype === 3) {
        item.AttributeValue = `${from.year}${from.month}~${to.year}${to.month}`;
        item.AttributeValueName = `${from.year}${from.month}~${to.year}${to.month}`;
      } else if (item.DemoInputtype === 9) {
        item.AttributeValue = from;
        item.AttributeValueName = from;
      } else {
        this.checkToMoreFrom(from, to);
        this.checkMaxMin(from, to);
        item.AttributeValue = `${from}~${to}`;
        item.AttributeValueName = `${from} to ${to}`;
      }
      if (this.inputError.length > 0) {
        return false;
      } else {
        this.inputFrom = "";
        this.inputTo = "";
        return item;
      }
    },
    cleanDemos() {
      this.$store.commit("order/clearDemos");
    },
    deleteDemos() {
      for (let item of this.unSelectedDemos) {
        this.$store.dispatch("order/deleteDemo", item);
      }
    },
  },
};
</script>
  
<style scoped lang="scss">
.all-hosehodls {
  margin-top: 16px;
}

.item-box {
  /*margin-left: 16px;*/
  position: relative;
  display: block;
}

.icon-close {
  margin-left: 32px;
  margin-right: 16px;
}

.item {
  margin-bottom: 16px;
}

.btns {
  margin-left: 8px;
  padding-top: 4px;
}

.btns-block {
  display: inline-block;
  width: 80px;
}

.custom-checkbox {
  min-height: 1rem;
}

.fold-icon {
  vertical-align: sub;
}

.custom-control-input:checked ~ .custom-control-label::before {
  border-color: green !important;
  background-color: green !important;
}

.lable-name {
  margin-bottom: 0px;
}

.add-btn {
  margin: 8px;
}

.add-p {
  margin: 4px;
}
</style>
  


// WEBPACK FOOTER //
// src/components/demo/MDemoSelectItem.vue